import { render, staticRenderFns } from "./DraggableItemGrid.vue?vue&type=template&id=a7903e44&scoped=true&"
import script from "./DraggableItemGrid.vue?vue&type=script&lang=js&"
export * from "./DraggableItemGrid.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItemGrid.vue?vue&type=style&index=0&id=a7903e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7903e44",
  null
  
)

export default component.exports